<template>
  <div class="app-wrapper">
    <YouTubeAffiliateTracker />
  </div>
</template>

<script>
import YouTubeAffiliateTracker from './components/YouTubeAffiliateTracker.vue'

export default {
  name: 'App',
  components: {
    YouTubeAffiliateTracker
  }
}
</script>

<style>
body {
  background-color: #F3F4F6;
  margin: 0;
  padding: 0;
}

.app-wrapper {
  min-height: 100vh;
}
</style>